module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r6n5n1r-b936cc7f76e2bf9009a6c9ae2ce7383d.svg";